import React from "react"

import pageComponent from "../common/page-component-hoc"

import UsersListWidgetContainer from "./users-list/UsersListWidgetContainer"
import UserFilterWidgetContainer from "./user-filter/UserFilterWidgetContainer"
import User from "./user-item/User"
import { userItemRequest } from "../../actions/user-actions"

const UsersComponent = ({ isFilterActive }) => (
    <div id="users" className="widgets-container clearfix row">
        <div
            className="col-xs-12 col-md-6 col-lg-5 col-xl-4 widget-list"
            id="users-list"
        >
            {isFilterActive ? (
                <UserFilterWidgetContainer />
            ) : (
                <UsersListWidgetContainer />
            )}
        </div>
        <User />
    </div>
)

export default pageComponent("users", userItemRequest)(UsersComponent)
